import { Component, OnInit } from "@angular/core";
import { Store, select } from "@ngrx/store";
import { Observable, takeUntil } from "rxjs";
import { BaseComponent } from "src/app/base.component";
import { LocationAvailabilityEnum } from "src/app/shared/enum/location-availability";
import { ObjectiveTypeEnum } from "src/app/shared/enum/objectives";
import { AdDetailsInterface } from "src/app/shared/models/advertising-campaigns/ad-details.interface";
import {
  TotalPrice,
  TotalPriceWithDiscount,
} from "src/app/shared/models/calcul/totalPrice";
import { LocationPartnerInterface } from "src/app/shared/models/location-partners/locationPartner.interface";
import { BadgeService } from "src/app/shared/services/badge.service";
import { adDetailsSelector, getAdCompaignByHashedIdSelector } from "src/app/store/advertisingCampaign/advertiserCampaign.selectors";
import { AppStateInterface } from "src/app/store/appState.interface";
import {
  calculateTotalLPPriceByCampanyNamesSelector,
  locationPartnersToCreateCampaignResultSelector,
} from "src/app/store/locationPartner/location-partner.selectors";

import { CalculatePrice } from "src/app/shared/models/calcul/calculatePrice";
import { cloneDeep } from "lodash";
import { LocationSearchMethod } from "src/app/shared/enum/locationSearchMethod";
import { initialState } from "src/app/store/advertisingCampaign/advertisingCampaign.reducers";
import { NewCampaignCalculatorService } from "src/app/shared/services/calculations/new-campaign.service";
import { AdvertisingCampaignInterface } from "src/app/shared/models/advertising-campaigns/advertising-campaign.interface";

@Component({
  selector: "app-by-location",
  templateUrl: "./by-location.component.html",
})
export class ByLocationComponent extends BaseComponent implements OnInit {
  notAvailableExists: boolean = false;
  getLocationPartnersCompanyNames: string[] | null;

  selectedLocations: string[] = [];

  calculateTotalLPCostByCampanyNames$: Observable<TotalPriceWithDiscount | null>;
  calculateTotalLPCostByCampanyNames: TotalPrice[] = [];

  locationSelected: TotalPrice;
  partiallyAvailableLocationEnum = LocationAvailabilityEnum.PARTIALLY;

  //companyNamesBySubCategoriesAndTag
  locationPartnersToCreateCampaignResult$: Observable<
    LocationPartnerInterface[] | null
  >;
  locationPartnersResult: LocationPartnerInterface[];

  adDetails$: Observable<AdDetailsInterface>;
  adDetails: AdDetailsInterface = initialState.adDetails;
  calculatePrice: CalculatePrice = {
    calculationMethod: LocationSearchMethod.LOCATION_PARTNER,
    names: [],
    objectiveName: ObjectiveTypeEnum.BRAND_AWARENESS_AND_REACH,
    startDate: null,
    endDate: null,
    checkDates: true
  };

  adByHashedId$: Observable<AdvertisingCampaignInterface | null>;

  objectiveName: ObjectiveTypeEnum;
  
  constructor(
    public badgeService: BadgeService,
    private store: Store<AppStateInterface>,
    public newCampaignCalculatorService: NewCampaignCalculatorService
  ) {
    super(store);
    this.adDetails$ = this.store
      .pipe(select(adDetailsSelector))
      .pipe(takeUntil(this.ngDestroyed$));

    this.locationPartnersToCreateCampaignResult$ = this.store
      .pipe(select(locationPartnersToCreateCampaignResultSelector))
      .pipe(takeUntil(this.ngDestroyed$));

    this.calculateTotalLPCostByCampanyNames$ = this.store
      .pipe(select(calculateTotalLPPriceByCampanyNamesSelector))
      .pipe(takeUntil(this.ngDestroyed$));

    this.adByHashedId$ = this.store
          .pipe(select(getAdCompaignByHashedIdSelector))
          .pipe(takeUntil(this.ngDestroyed$));
  }

  ngOnInit(): void {
    this.calculateTotalLPCostByCampanyNames$.subscribe(
      (value: TotalPriceWithDiscount | null) => {
        this.notAvailableExists = false;
        if (value != null) {
          this.calculateTotalLPCostByCampanyNames = value.totalPricePerDay;
          this.selectedLocations = this.calculateTotalLPCostByCampanyNames.map(
            (location) => location.companyName
          );
          value.totalPricePerDay.map((lp) => {
            if (
              lp.availabilities.availabilityStatus ==
                LocationAvailabilityEnum.NOT_AVAILABLE ||
              lp.availabilities.availabilityStatus ==
                LocationAvailabilityEnum.CURRENTLY_INSTALLING
            )
              this.notAvailableExists = true;
          });
        }
      }
    );
    this.adDetails$.subscribe((adDetails) => {
      this.adDetails = adDetails;
      if (this.adDetails != adDetails) {
        if (this.adDetails.calculationMethod != adDetails.calculationMethod)
          this.selectedLocations = [];
        this.onChangeCalculateCost();
      }
    });

    //get locations filtred by region
    this.locationPartnersToCreateCampaignResult$.subscribe(
      (result: LocationPartnerInterface[] | null) => {
        if (result != null) {
          this.locationPartnersResult = result;
          this.getLocationPartnersCompanyNames = result.map(
            (value) => value.companyName
          );
        }
      }
    );

    this.adByHashedId$.subscribe((result) => {
      if (result) {
        this.objectiveName = result.objectiveName;
      }
    });
  }

  selectAllLocations(event: any) {
    if (event.target.checked)
      this.selectedLocations = cloneDeep(
        this.getLocationPartnersCompanyNames ?? []
      );
    else this.selectedLocations = [];

    this.onChangeCalculateCost();
  }

  CheckLocationSelectedAll(): boolean {
    return (
      this.getLocationPartnersCompanyNames?.length ==
      this.selectedLocations.length
    );
  }

  onChangeCalculateCost() {
    this.newCampaignCalculatorService.onSelectCalculatePrice(
      this.adDetails.startDate,
      this.adDetails.endDate,
      this.objectiveName ?? this.adDetails.objectiveName,
      this.adDetails.calculationMethod,
      this.selectedLocations
    );
  }
}
